Spooler = (function() {
  var taskList = [], isRunning = false, faileds = [];

  function fileValidator( acceptedFiles, file ) {
    var baseMimeType, i, len, mimeType, validType;

    // If file size is higher than 2mb, decline upload request
    if ( file.size > rhh_image_config.max_file_size ) {
      swal('Hiba!', 'A fájl mérete túl nagy, kérem töltsön fel kisebb fájlt mint 2 megabájt!', 'warning');
      return false;
    }

    // If file type is anything other than PNG or JPG
    if ( file.type !== 'image/jpeg' && file.type !== 'image/png' ) {
      swal('Hiba!', 'A fájl típusa nem megfelelő, az engedett fájltípusok: JPG, PNG!', 'warning');
      return false;
    }

    if ( ! ( file instanceof File ) ) {
      return;
    }

    if ( ! acceptedFiles ) {
      return true;
    }

    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");

    for ( i = 0, len = acceptedFiles.length; i < len; i++ ) {
      validType = acceptedFiles[i];
      validType = validType.trim();

      if ( validType.charAt(0) === "." ) {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if ( /\/\*$/.test( validType ) && baseMimeType === validType.replace( /\/.*$/, "" ) ) {
        return true;
      } else if ( mimeType === validType ) {
        return true;
      }
    }

    Spooler.failed = file;
    return false;
  }

  function trigger(form) {
    if( taskList.length ) {
      form.trigger('submit');
    }
  }

  Spooler.prototype.faileds = function() {
    return faileds;
  };

  Spooler.prototype.get = function() {
    return _(taskList).pullAt(0).first();
  };

  Spooler.prototype.isWaiting = function() {
    return taskList.length;
  };

  Spooler.prototype.bind = function() {
    trigger(this.form);
  };

  Spooler.prototype.add = function(files) {
    taskList = taskList.concat(
      _.filter(files, _.partial(fileValidator, this.acceptedFiles))
    );
    trigger(this.form);
  };

  function Spooler($form, acceptedFiles) {
    if ( ! ( $form instanceof jQuery ) ) {
      return false;
    }

    var info = $('.box__info',$form);
    this.form = $form;
    this.acceptedFiles = acceptedFiles;

    try {
      if(!Object.getOwnPropertyDescriptor(Spooler,'failed')) {
        Object.defineProperty(Spooler, 'failed', {
          set: function(file) {
            faileds.push(file);
            var prefix = ', ';
            if(!info.html().length) {
              prefix = 'Nem lehet feltölteni: ';
              info.show(500);
            }
            info.append(prefix + file.name);
          },
          configurable: false
        });
      }
    } catch (e) {}
  }

  return Spooler;
})();

$(function(){
  isAdvancedUpload = function() {
    var div = document.createElement( 'div' );
    return ( ( 'draggable' in div ) || ( 'ondragstart' in div && 'ondrop' in div ) ) && 'FormData' in window && 'FileReader' in window;
  }();

  var $form           = $('#images_container').append('<input type="hidden" name="ajax" value="1">'),
      $input          = $form.prev('input[type="file"]'),
      $uploadBox      = $('.box__uploading',$form),
      $list_container = $('#sorting-images-container'),
      spooler         = new Spooler($form, $input.data('allowed')),
      local = {
        images_list: _.get($('.images_list'),'[0].swiper'),
      },
      locations = {
        images: /^image\/\w+$/,
      };

  $('.zurb.switchlist').on('click', 'a.enter', function(e) {
    $form.addClass('list-mode');
    $('.images_list').remove();
  }).on('click', '.listcontroll a.exit', function(e) {
    $.post(seturl($(this)), {
      act: 'getlist',
      partnerid: _.get($,'ajaxSettings.data.partnerid'),
    }, function(result) {
      $('.switchlist').after(result.html).ready(function () {
        var swiper = new Swiper('.images_list', settings.imagesList);
        local.images_list = swiper;
      });

      $form.removeClass('list-mode');
    });
  });

  if($list_container[0]) {
    local.sortable = Sortable.create($list_container[0], {
      handle:    '.dd',
      animation: 50,
      draggable: '.imagec',
      //dataIdAttr: 'data-sort',
      onUpdate: function (e) {
        $('.listcontroll > .save-list').removeClass('disabled');
      },
    });
  }

  $('.listcontroll').on('click', '.save-list:not(.disabled)', function(e) {
    let $this = $(this),
        url   = $this.data('url'),
        $el   = $('.imagec',$list_container),
        data  = {act: 'modify', data: getImagesProps() }, //form2js($el[0], '.', false),
        partnerid = _.get($,'ajaxSettings.data.partnerid');

    if(partnerid) {
      data.partnerid = partnerid;
    }

    $el.addClass('disabled').removeClass('ready');
    $this.addClass('disabled');

    $.post(seturl($this), data, function(result) {
      $el.removeClass('edited');
    }).fail(function(data) {
      $this.removeClass('disabled');
    }).always(function(xhr) {
      $el.removeClass('disabled').addClass('ready');
    });
  });

  $list_container.on('change keyup keypress', '.ready input, .ready textarea, .ready select', function(e) {
    var $this = $(this),
      $el   = $this.closest('.imagec'),
      inputs = _( $( 'input[type="text"].input-group-field',$el ) ),
      isHinged = !!inputs.pluck('value').join('').length ? 'add' : 'remove';

    inputs.pluck('value','dataset.enable').each(function(val,id){
      var txtbox = $('#'+id).attr('readonly', !val).get(0) || {};
      txtbox.value = val ? txtbox.value : '';
    });

    $el.addClass('edited').Class(isHinged,'hinged');
    $('.listcontroll > .save-list').removeClass('disabled');
  });

  if(local.images_list instanceof Swiper) {
    $('.contcont').on('click', '.images_list .swiper-slide-active', function(e){
      var $url    = $(e.target).data('url'), cropper;
      local.image = $('.image-editor img')[0];
      local.currentEditedSlide = local.images_list.clickedIndex;
      $('.images_list').addClass('disabled');

      local.image.src = $url+'?'+moment().unix();
      local.imgPath = _($url).split('static').last();
      local.imgId =  $(e.target).data('id');
      settings.local.cropper = local.cropper = new Cropper(local.image, settings.cropper);
      local.cont = $('.image-editor, .images_list');
      $form.addClass('editor-mode');
    });

    local.editorbuttons = $('.editorbuttons').on('click', 'a.button', function(e) {
      let data = e.currentTarget.dataset;
      let action = _.method(data.act, data.val);
      action(local.cropper);
    }).on('click', 'a.imgaction', function(e) {
      let canvas  = local.cropper.getCroppedCanvas();
      let dataset = _.toPlainObject(e.currentTarget.dataset);

      if(dataset.act === 'cancel') {
        $('.images_list').removeClass('disabled');
        $form.removeClass('editor-mode');

        if(_.isFunction(_.get(local,'image.cropper.destroy'))) {
          local.image.cropper.destroy();
        }

        return;
      }

      local.cont.addClass('disabled');
      dataset.imgPath = local.imgPath;
      dataset.imgId = local.imgId;
      dataset.partnerid = settings.getMeta('partnerid');

      if(!(dataset.act === 'delete')) {
        dataset.blob = canvas.toDataURL('image/jpeg');
      }

      $.post(local.editorbuttons.data('url'), dataset, function(result) {
        local.cont.removeClass('disabled');
        $form.removeClass('editor-mode');

        if(dataset.act === 'save') {
          let tturl = _.get(local, 'images_list.clickedSlide.dataset.url') + '?' + moment().unix();
          _.set(local, 'images_list.clickedSlide.style.backgroundImage', 'url(' + tturl + ')');
          $list_container.find('.dropdown-pane[data-id="' + local.imgId + '"]>img').attr('src', tturl);
        }

        if(_.isFunction(_.get(local,'image.cropper.destroy'))) {
          local.image.cropper.destroy();
        }

        if(dataset.act === 'delete') {
          // Képek törlése a galériából mindenhonnan
          local.images_list.removeSlide(local.currentEditedSlide);
          settings.local.imggalery.removeSlide(local.currentEditedSlide);
          $list_container.find('[data-id="'+local.imgId+'"]').remove();
          delete local.currentEditedSlide; delete local.imgId;

          if(!_.get(local,'images_list.slides.length')) {
            $('.images_list, .switchlist').addClass('hide');
          }
        }
      });
    });

  }
  if(isAdvancedUpload) {
    $form.addClass('has-advanced-upload')
      .on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }).on('dragover dragenter', function() {
      $form.addClass( 'is-dragover' );
    }).on('dragleave dragend drop', function() {
      $form.removeClass( 'is-dragover' );
    }).on('drop', function(e) {
      spooler.add(e.originalEvent.dataTransfer.files);
    }).on('click', function() {
      if(!$(this).hasClass('is-uploading')) {
        $input.click();
      }
    });
  }

  $input.on('change', function(e) {
    spooler.add(e.currentTarget.files);
  });

  $form.on('submit', function(e) {
    if($form.hasClass('is-uploading')) {
      return false;
    }

    let file   = spooler.get();
    let failed = _(spooler.faileds).pluck('name').join(', ');
    $form.removeClass('is-error is-success');

    if(isAdvancedUpload) {
      e.preventDefault();

      //$input.attr('name').replace('[]','');
      var dir  = _(locations).pickBy(_.method('test',file.type)).keys().first(),
        data = new FormData($form[0]);

      data.append(dir, file);
      data.append('partnerid', settings.get('meta.partnerid'));

      $form.addClass('is-uploading');
      $('.box__uploading label').html(file.name);
      $.ajax({
        url:          seturl('upload', dir, {join: '/'}),
        data:         data,
        metod:        'POST',
        dataType:     'json',
        cache:        false,
        contentType:  false,
        processData:  false,
        xhr: function() {
          myXhr = $.ajaxSettings.xhr();

          if(myXhr.upload) {
            myXhr.upload.addEventListener('progress', showProgress, false);
          }

          return myXhr;
        }
      }).done(function(data) {
        if (typeof data.error !== 'undefined') {
          swal( 'Hiba!', data.error, 'error' );
          return;
        }

        _(data.newItems).forEach(function(item) {
          var $listitem = $(_.toString(item.list).replace(/\n|  /ig,' '));
          // Képek hozzáadása a galériához
          local.images_list.appendSlide(item.slide);
          settings.local.imggalery.appendSlide(item.list);
          $list_container.append(item.listitem);

          $listitem.foundation();
          $list_container.foundation();
        });
        if(!_.isEmpty($('.images_list.hide, .switchlist.hide').removeClass('hide')))
          local.images_list.init();
        $form.addClass('is-success').removeClass('is-error');
      }).fail(function(data) {
        $form.addClass('is-error').removeClass('is-success');
      }).always(function() {
        _.delay(uploadEnd, 3000);
      });
    } else {
      var iframeName  = 'uploadiframe' + new Date().getTime(),
        $iframe   = $( '<iframe name="' + iframeName + '" style="display: none;"></iframe>' );

      $form.addClass('is-uploading');
      $('body').append($iframe);
      $form.attr('target', iframeName);

      $iframe.one('load', function() {
        var data = $.parseJSON( $iframe.contents().find( 'body' ).text() );
        $form.removeClass('is-uploading').addClass( data.success == true ? 'is-success' : 'is-error' ).removeAttr('target');
        $iframe.remove();
      });
    }
  });

  $('.contcont').on('click', '.add-deal-image', function(e){
    e.preventDefault();
    var $t = $(this),
      $el = $t.closest('.edited-cards');
    selectFromGalery(function(img) {
      //_(img).split('/static/').last()
      //$t.closest('.deal-image').html('<input type="hidden" name="images" value="' + _(img).split('/data/').last() + '"><img src="'+img+'"><a class="alert small button del-deal-image"><i class="fa fa-trash" aria-hidden="true"></i></a>');
      $t.closest('.deal-image').html('<img src="'+img+'"><a class="alert small button del-deal-image"><i class="fa fa-trash" aria-hidden="true"></i></a>');
      $('.deal-image-id',$el).val(_(img).split('/data/').last());
      $el.addClass('edited');
      $('.save',$el).removeClass('disabled');
    });
  }).on('click', '.del-deal-image', function(e){
    e.preventDefault();
    var $t = $(this),
      $el = $t.closest('.edited-cards');

    $t.closest('.deal-image').html('<a class="add-deal-image" data-toggle="image-select-galery"><i class="fa fa-picture-o" aria-hidden="true"></i></a>');
    $('.deal-image-id',$el).val('');
    $el.addClass('edited');
    $('.save',$el).removeClass('disabled');
  });

  function showProgress(e) {
    var progress = _.toInteger(100 * e.loaded / e.total);
    $('.progress',$uploadBox).attr('aria-valuenow', progress).attr('aria-valuetext',progress+' százalék');
    $('.progress-meter',$uploadBox).css('width', progress+'%');
    $('.progress-meter-text',$uploadBox).html(progress+'%');
  }

  function uploadEnd() {
    $form.removeClass('is-success is-uploading is-error');
    $('.box__uploading label').html('');
    if(spooler.isWaiting())
      $form.trigger('submit');
  }

  function selectFromGalery(cb) {
    if(!_.isFunction(cb))
      return;

    $('#image-select-galery').on('click', '.select-image', function(){
      cb($(this).data('url'));
    });
  }

  function getImagesProps() {
    return _.toArray(form2js($list_container[0], '.', false));
  }

  _.extend(settings.local,local);
  _.extend(settings, {
    spooler: spooler,
  });

});

$(function(){

  var i = 1,
    $abide = $('form.registration');
  $newC = $('li.price')[0], $priceAll = $('li.price.priceAll'),
    newCounter = $('li.price'),
    $counter = $('li.price')[0];
  //sendfeatsearcdata = [];

  var $box = $('select.sumobox');

  $box.SumoSelect({
    csvDispCount:             2,
    captionFormat:            '{0} kiválasztva',
    captionFormatAllSelected: 'Az összes kiválasztva!',
    placeholder:              $box.data('placeholder') || 'Válassz...',
    search:                   false,
    triggerChangeCombined:    true
  });

  if($abide.length) {
    // ------------------- CSAK HA REGISZTRÁCIO VAN ---------------------------------------------

    // A6   Helyszin / féléves
    // A12  Helyszin / egyéves
    // A424 Helyszin / kétéves

    // B6  egyéb / féléves
    // B12 egyéb / egyéves
    // B24 egyéb / kétéves

    var lastPrice = 0;

    function checkPrice() {
      var szolg, period, prices = {A: {6: 6500, 12: 5700, 24: 4700}, B: {6: 4000, 12: 3500, 24: 3000}},
        dd = _($('select[name="contract[contract_period]"], select[name="contract[payment_period]"], input[name="partner[category]"]:checked, #pp-connect')).map(function (el) {
          if (el.name === "partner[category]")
            return 1 < (v = _.toInteger(el.value)) ? 'B' : (v === 1 ? 'A' : null);
          if (el.name === "contract[contract_period]")
            return _.toInteger(el.value);
          if (el.id === "pp-connect")
            return el.checked && -0.1;
        }),
        price = _.get(prices, [(szolg = dd.filter(_.isString).first()), (period = dd.filter(_.isInteger).first())]);
      return [price + (price * (dd.indexOf(-0.1) > -1 ? -0.1 : 0)), period];
    }

    $('select[name="contract[contract_period]"], select[name="contract[payment_period]"], input[name="partner[category]"], #pp-connect').on('change', function (el) {
      var period, newprice, n = checkPrice();
      newprice = n[0], period = n[1]
      newCounter.removeClass('invalidPrice');
      if (newCounter[0]) {
        if (!newprice) {
          newCounter.addClass('invalidPrice');
        }
        $priceAll.html('Összesen: ' + (_.toInteger(newprice) * _.toInteger(period)).cformat(' Ft'));
      }
      //ccc = new CountUp($counter, _.toInteger(lastPrice), _.toInteger(newprice), 0, 2.7, settings.countup);
      ccc = new CountUp($counter, 6900, _.toInteger(newprice), 0, 2.7, settings.countup);
      ccc.start();
      lastPrice = newprice;
    }).trigger('change');

    $('#contacts').on('click', '.close-button', function (e) {
      $(this).closest('.addcontact[data-closable]').remove();
      var db = $('.addcontact').length;
      if (db < 5) $('.contactadd').removeClass('disabled');
      $('.counter').html(db < 2 ? '' : db);
      //Foundation.reInit($abide);
    });

    $('.contactadd').on('click', function addContact() {
      var db = $('.addcontact').length + 1;
      if (db > 5)
        return;
      var html = $('#addcontact').html().replace(/%count%/ig, $('#contacts .ccard').length);
      $('#contacts').append(initContentFields(html).fadeIn(1000, function () {
        $('.contactadd .counter').html(db);
        if (db >= 5) $('.contactadd').addClass('disabled');
        //Foundation.reInit($abide);
      }));
      i++;
    });

    $('form.registration .tabs-content [aria-hidden=true] input.req').removeAttr('required');
    $('form.registration').on('change.zf.tabs', '.tabs', function (e, $el) {
      if ($el instanceof jQuery) {
        $('input#companytype').val($el.data('companytype'));
        $('.tabs-content input.req', $abide).removeAttr('required').attr('disabled', true);
        $('.tabs-content .is-active input.req', $abide).attr('required', true).removeAttr('disabled');
        Foundation.reInit($abide);
      }
    });

  }
  var $billedit = $('form.bill-edit');
  if($billedit[0]) {
    $('form.bill-edit .tabs-content [aria-hidden=true] input.req').removeAttr('required').attr('disabled',true);
    $('form.bill-edit').on('change.zf.tabs', '.tabs', function(e, $el) {
      if($el instanceof jQuery) {
        //console.log($el);
        $('input#companytype').val($el.data('companytype'));
        $('.tabs-content input.req',$billedit).removeAttr('required').attr('disabled',true);
        $('.tabs-content .is-active input.req', $billedit).attr('required',true).removeAttr('disabled');
        Foundation.reInit($billedit);
      }
    });
  }


  // -----------------------------------------------------------------------------------------------

  $('.selectnew input[type=radio]').on('change', function(e){
    var $hide = $('.pricing-table .hide'),
      $checkd = $('input[name="partner[category]"]:checked'),
      bkg = $('+.circle',$checkd).css('background-image'),
      txt = $('~.partnername',$checkd).text();

    if($checkd.length && _.first(checkPrice())) {
      $('.partner .circle').css('background-image',bkg);
      $('.partner label>h6').text(txt);

      if($field = $('.custom-partner:not(:visible).hide')) {
        $field.removeClass('hide').fadeIn(500);
      }
    }
  }).trigger('change');

  $('.copyfinance').on('click', function() {
    $('.ccard.admin input').each(function() {
      name = 'input[name="'+($(this).attr('name') || '').replace('user', 'contacts[1]').replace('copy', '')+'"]';
      if($(this).val())
        $(name).val($(this).val());
      //console.log(name);
    });
  });

  $('.ccard.admin input#useremailsrc').on('keyup keypress change', function() {
    $('#useremailcc').val($(this).val());
  });

/// Találati igénylés ///

  $(".formorder .add").click(
    function(e){
      e.preventDefault();
      var
        form	= $(this).closest(".formorder"),
        $this = $(this),
        region = $(".region", form).val(),
        regionText = $(".region option:selected", form).text(),
        headcount = $(".headcount", form).val(),
        headcountText = $(".headcount option:selected", form).text(),
        yearmonth = _($(".yearmonth", form).val()).split('-'),
        yearmonthtext = _($(".yearmonth option:selected", form).text()).split(' '),
        year = yearText = yearmonth.first(),
        month = yearmonth.last(),
        monthText = yearmonthtext.last();

      var html =
        '<tr class="orderrow">' +
        '<td><input type="hidden" name="region[]" value="'+ region +'">' + regionText + '</td>' +
        '<td><input type="hidden" name="headcount[]" value="'+ headcount +'">' + headcountText + '</td>' +
        '<td><input type="hidden" name="year[]" value="'+ year +'">' + yearText + '</td>' +
        '<td><input type="hidden" name="month[]" value="'+ month +'">' + monthText + '</td>' +
        '<td><a href="#" class="remove">Eltávolít</a></td>' +
        '</tr>';
      $(".listcontainer", form).append(html);
    }
  );

  $(".sysformorder .add").click(
    function(e){
      e.preventDefault();
      var
        form	= $(this).closest(".sysformorder"),
        $this = $(this),
        deal = $(".deals", form).val(),
        dealText = $(".deals option:selected", form).text(),
        paidornot = $(".paidornot", form).val(),
        paidornotText = $(".paidornot option:selected", form).text(),
        mainorcat = $(".mainorcat", form).val(),
        mainorcatText = $(".mainorcat option:selected", form).text(),
        type = $(".type", form).val(),
        typeText = $(".type option:selected", form).text(),
        region = $(".region", form).val(),
        regionText = $(".region option:selected", form).text(),
        headcount = $(".headcount", form).val(),
        headcountText = $(".headcount option:selected", form).text(),
        dateon = $(".dateon", form).val(),
        dateoff = $(".dateoff", form).val();

      if(deal) {
        var html =
          '<tr class="orderrow">' +
          '<td><input type="hidden" name="deal[]" value="'+ deal +'">' + dealText + '</td>' +
          '<td><input type="hidden" name="paidornot[]" value="'+ paidornot +'">' + paidornotText + '</td>' +
          '<td><input type="hidden" name="mainorcat[]" value="'+ mainorcat +'">' + mainorcatText + '</td>' +
          '<td><input type="hidden" name="type[]" value="'+ type +'">' + typeText + '</td>' +
          '<td><input type="hidden" name="dateon[]" value="'+ dateon +'">' + dateon + '</td>' +
          '<td><input type="hidden" name="dateoff[]" value="'+ dateoff +'">' + dateoff + '</td>' +
          '<td><a href="#" class="remove">Eltávolít</a></td>' +
          '</tr>';
        $(".listcontainer", form).append(html);
      }
      else {
        var html2 =
          '<tr class="orderrow">' +
          '<td><input type="hidden" name="paidornot[]" value="'+ paidornot +'">' + paidornotText + '</td>' +
          '<td><input type="hidden" name="mainorcat[]" value="'+ mainorcat +'">' + mainorcatText + '</td>' +
          '<td><input type="hidden" name="type[]" value="'+ type +'">' + typeText + '</td>' +
          '<td><input type="hidden" name="region[]" value="'+ region +'">' + regionText + '</td>' +
          '<td><input type="hidden" name="headcount[]" value="'+ headcount +'">' + headcountText + '</td>' +
          '<td><input type="hidden" name="dateon[]" value="'+ dateon +'">' + dateon + '</td>' +
          '<td><input type="hidden" name="dateoff[]" value="'+ dateoff +'">' + dateoff + '</td>' +
          '<td><a href="#" class="remove">Eltávolít</a></td>' +
          '</tr>';
        $(".listcontainer", form).append(html2);
      }
    }
  );

  $(".listcontainer").delegate(".remove", "click", function(e){
    e.preventDefault();
    $(this).closest(".orderrow").remove();
  });


  $('.personadd-button').click(function(e) {
    var partnerid = $(this).data('partnerid'),
      type = $(this).data('type');
    $('#personadd .partner_id').val(partnerid);
    $('#personadd .person_type').val(type);
    $('#personadd').foundation('open');
  });

  $('.personmod-button').click(function(e) {
    var personid = $(this).data('personid'),
      partnerid = $(this).data('partnerid'),
      type = $(this).data('person_type'),
      firstname = $(this).data('firstname'),
      forename = $(this).data('forename'),
      name = $(this).data('name'),
      phone = $(this).data('phone'),
      mobile = $(this).data('mobile'),
      email = $(this).data('email');
    $('#personmod .personid').val(personid);
    $('#personmod .partner_id').val(partnerid);
    $('#personmod .type').val(type);
    $('#personmod .firstname').val(firstname);
    $('#personmod .forename').val(forename);
    $('#personmod .name').val(name);
    $('#personmod .phone').val(phone);
    $('#personmod .mobile').val(mobile);
    $('#personmod .email').val(email);
    $('#personmod').foundation('open');
  });

});

//# sourceMappingURL=partneradmin.js.map
